(() => {
  'use strict';
  // Layout owns this component. Delegation survives section replacement without
  // attaching another listener to every header/editor invocation.
  if (window.DimMakingHelp?.componentVersion === 1) return;
  let dialog = null;
  let invoker = null;
  let departingSection = null;
  const visible = (node) => Boolean(node?.isConnected && !node.disabled &&
    !node.closest('[hidden], [inert], [aria-hidden="true"]') && node.getClientRects().length);
  const restoreFocus = () => {
    const usable = node => visible(node) && !departingSection?.contains(node);
    const target = usable(invoker) ? invoker : [...document.querySelectorAll('[data-e-help-open], [data-dim-header-logo]')].find(usable);
    invoker = null;
    departingSection = null;
    target?.focus({ preventScroll: true });
  };
  const close = () => { if (dialog?.open) dialog.close(); };
  const cancel = (event) => { event.preventDefault(); close(); };
  const initialise = () => {
    const current = document.querySelector('#DimMakingHelp');
    if (current === dialog) return;
    if (dialog) {
      dialog.removeEventListener('close', restoreFocus);
      dialog.removeEventListener('cancel', cancel);
      if (dialog.open) dialog.close();
      restoreFocus();
    }
    dialog = current;
    dialog?.addEventListener('close', restoreFocus);
    dialog?.addEventListener('cancel', cancel);
  };
  document.addEventListener('click', (event) => {
    const dismiss = event.target.closest?.('[data-making-help-close]');
    if (dismiss && dialog?.contains(dismiss)) { close(); return; }
    const trigger = event.target.closest?.('[data-e-help-open], [data-e-editor-help]');
    if (!trigger || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    initialise();
    // Real Help links remain usable without dialog support or on failure.
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (dialog.open) { event.preventDefault(); return; }
    document.dispatchEvent(new CustomEvent('dreamit:making-help:before-open', { detail: { invoker: trigger } }));
    invoker = trigger;
    try {
      dialog.showModal();
      event.preventDefault();
    } catch (_) { invoker = null; }
  });
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:unload', (event) => {
    if (invoker && event.target?.contains(invoker)) {
      departingSection = event.target;
      close();
    }
  });
  window.DimMakingHelp = { componentVersion: 1, close };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
